<div class="section-header" [dataSelector]="dataSelector + '-header'">
  <div class="section-header-content" [dataSelector]="dataSelector + '-header-content'">
    <div class="section-title" [dataSelector]="dataSelector + '-title'">
      <h2
        class="h2-500"
        [class.expanded]="isTitleExpanded()"
        [dataSelector]="dataSelector + '-name'"
        (click)="toggleTitleExpansion()"
      >
        @if ((enableReferenceId$ | async) && section().referenceId) {
          <span class="reference-id">{{ section().referenceId }}. </span>
        }
        {{ section().name }}
      </h2>

      <span class="body-400 color-gray-500" [dataSelector]="dataSelector + '-count'">({{ section().items?.length ?? 0 }} Requests)</span>
    </div>
    
    <div class="section-summary" [dataSelector]="dataSelector + '-summary'">
      <span class="body-400 color-gray-100" tooltip="Open" [dataSelector]="dataSelector + '-open-count'">
        <awn-badge [dataSelector]="dataSelector + '-open-badge'"></awn-badge>
        {{ openItemsCount() }}
      </span>
      
      <span class="body-400 color-gray-100" tooltip="In Review" [dataSelector]="dataSelector + '-in-review-count'">
        <awn-badge color="yellow" [dataSelector]="dataSelector + '-in-review-badge'"></awn-badge>
        {{ inReviewItemsCount() }}
      </span>
      
      <span class="body-400 color-gray-100" tooltip="Changes Requested" [dataSelector]="dataSelector + '-rejected-count'">
        <awn-badge color="red" [dataSelector]="dataSelector + '-rejected-badge'"></awn-badge>
        {{ rejectedItemsCount() }}
      </span>
      
      <span class="body-400 color-gray-100" tooltip="Accepted" [dataSelector]="dataSelector + '-approved-count'">
        <awn-badge color="green" [dataSelector]="dataSelector + '-approved-badge'"></awn-badge>
        {{ approvedItemsCount() }}
      </span>
    </div>
  </div>

  <hr class="separator" [dataSelector]="dataSelector + '-separator'"/> 
</div>


<ng-content></ng-content>
